export const SINGLE_RANK = 'singleRank' // 单榜
export const MULTI_RANK = 'multiRank'  // 总榜